import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { Association } from "../association";
import { Group } from "../group";
import { Opportunity } from "../opportunity";
import { OrganizationManager } from "../organization-manager";
import { PartnerOrganization } from "../partner-organization";
import { VolunteerOrganization } from "../volunteer-organization";
import { CommunicationRecordEntityConfig } from "./config";
import { CommunicationRecordFilters } from "./filters";
import { CommunicationRecordMethods } from "./methods";

@HyperEntity("communication-record", CommunicationRecordEntityConfig)
export class CommunicationRecord extends extender(
  CommunicationRecordFilters,
  CommunicationRecordMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "manager_id" })
  managerId = "";

  @Relations.toOne(() => OrganizationManager, "managerId")
  manager?: OrganizationManager;

  @Relations.toOne<CommunicationRecord, Group>(() => Group, {
    fields: {
      id: "groupId",
    },
  })
  group?: Group;

  @Relations.toOne<CommunicationRecord, Association>(() => Association, {
    fields: {
      id: "associationId",
    },
  })
  association?: Association;

  @Fields.string({ dbName: "association_id", allowNull: true })
  associationId?: string;

  @Fields.string({ dbName: "group_id", allowNull: true })
  groupId?: string;

  @Relations.toOne<CommunicationRecord, Opportunity>(() => Opportunity, {
    fields: {
      id: "opportunityId",
    },
  })
  opportunity?: Opportunity;

  @Fields.string({ dbName: "opportunity_id", allowNull: true })
  opportunityId?: string;

  @Fields.string({ dbName: "summer_campaign_lead_id", allowNull: true })
  summerCampaignLeadId?: string;

  @Fields.string({ dbName: "partner_organization_id", allowNull: true })
  partnerOrganizationId?: string;

  @Relations.toOne<CommunicationRecord, PartnerOrganization>(
    () => PartnerOrganization,
    "partnerOrganizationId",
  )
  partnerOrganization?: PartnerOrganization;

  @Fields.string({ dbName: "volunteer_organization_id", allowNull: true })
  volunteerOrganizationId?: string;

  @Relations.toOne<CommunicationRecord, VolunteerOrganization>(
    () => VolunteerOrganization,
    "volunteerOrganizationId",
  )
  volunteerOrganization?: VolunteerOrganization;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt: Date = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt: Date = new Date();

  @Fields.string()
  description = "";

  @Fields.string()
  type = "";

  @Fields.string({ allowNull: true })
  channel?: string | null;

  @Fields.string()
  title = "";
}
